import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { FB_LOGIN_FAVORITES } from 'commons/constants';
import { logError } from 'commons/logger';
import LoginSidebar from 'components/consumer/LoginSidebar/LoginSidebar';
import { setItemInStorage, removeItemInStorage } from 'commons/localStorage';
import { FAVORITE_PRODUCT } from 'mocks/mutations';
import { GET_FAVORITED_PRODUCT_IDS } from 'mocks/queries';
const FavoriteViewModal = ({
  optionValueId = null,
  onClose,
  productId,
  productName,
  swatchOption,
  isSideBarVisible = false
}) => {
  // V1 (not V2) deliberately: V2 is a toggle, and this path needs to set the
  // favorite state, not flip it - keepFavorited: true makes toggleUserFavorite
  // check server-side whether it's already favorited and no-op if so, so it
  // can't accidentally un-favorite an existing one.
  const [addToFavorites] = useMutation(FAVORITE_PRODUCT, {
    update: (cache, {
      data
    }) => {
      const {
        id,
        status
      } = data?.userFavoriteAction ?? {};
      if (!status || !id) {
        return;
      }
      const cached = cache.readQuery({
        query: GET_FAVORITED_PRODUCT_IDS
      });
      const favProductIds = cached?.productIds;
      if (!favProductIds || favProductIds.includes(id)) {
        return;
      }
      cache.writeQuery({
        query: GET_FAVORITED_PRODUCT_IDS,
        data: {
          productIds: [...favProductIds, id]
        }
      });
    }
  });
  useEffect(() => {
    if (isSideBarVisible && !optionValueId) {
      setItemInStorage(FB_LOGIN_FAVORITES, {
        productID: productId
      });
    }
  }, [isSideBarVisible, optionValueId, productId, productName, swatchOption]);
  const addPendingFavorite = useCallback(async () => {
    if (!productId) {
      return;
    }
    await addToFavorites({
      variables: {
        productID: productId,
        keepFavorited: true
      }
    });
  }, [addToFavorites, productId]);
  let loginSidebarProps = {
    show: isSideBarVisible,
    wishListProduct: productName,
    onClose,
    onLogin: async () => {
      onClose();
      try {
        await addPendingFavorite();
      } catch (e) {
        logError(e);
      } finally {
        removeItemInStorage(FB_LOGIN_FAVORITES);
      }
    }
  };
  if (optionValueId) {
    loginSidebarProps = {
      show: isSideBarVisible,
      onClose
    };
  }
  return <LoginSidebar {...loginSidebarProps} />;
};
FavoriteViewModal.propTypes = {
  optionValueId: PropTypes.number,
  onClose: PropTypes.func,
  productId: PropTypes.number,
  productName: PropTypes.string,
  swatchOption: PropTypes.object,
  isSideBarVisible: PropTypes.bool
};
export default FavoriteViewModal;